import { render, staticRenderFns } from "./ModalApproveTemuan.vue?vue&type=template&id=13b2c6a3&"
import script from "./ModalApproveTemuan.vue?vue&type=script&lang=js&"
export * from "./ModalApproveTemuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports